
import React from 'react';
import { Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuCheckboxItem, 
  DropdownMenuTrigger 
} from '@/components/ui/dropdown-menu';
import { AIModel } from '@/types';

interface ChatFiltersProps {
  showEmpty: boolean;
  setShowEmpty: (show: boolean) => void;
  filterModels: string[];
  setFilterModels: (models: string[]) => void;
  models: AIModel[];
}

const ChatFilters = ({ 
  showEmpty, 
  setShowEmpty, 
  filterModels, 
  setFilterModels, 
  models 
}: ChatFiltersProps) => {
  const handleModelFilterChange = (modelId: string, checked: boolean) => {
    if (checked) {
      // Create a new array with the added model ID
      const newFilterModels = [...filterModels, modelId];
      setFilterModels(newFilterModels);
    } else {
      // Create a new array without the removed model ID
      const newFilterModels = filterModels.filter(id => id !== modelId);
      setFilterModels(newFilterModels);
    }
  };

  return (
    <div className="flex gap-2 ml-auto">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="gap-2">
            <Filter size={16} />
            Filters
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuCheckboxItem
            checked={showEmpty}
            onCheckedChange={setShowEmpty}
          >
            Show empty chats
          </DropdownMenuCheckboxItem>
          
          {models.map(model => (
            <DropdownMenuCheckboxItem
              key={model.id}
              checked={filterModels.includes(model.id)}
              onCheckedChange={(checked) => handleModelFilterChange(model.id, checked)}
            >
              {model.name}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default ChatFilters;
